import { Checkbox, TableCell, TableRow } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/styles/withStyles";
import { RemittanceRunnerOrders_remittanceOrders_edges_node } from "@saleor/remittanceRunner/types/RemittanceRunnerOrders";
import { getDeliveryTypeString } from "@saleor/remittanceRunner/utils/handlers";
import React from "react";

import RemittanceRunnerRemittanceIsLoading from "../RemittanceRunnerRemittanceIsLoading";
import {
  RemittanceRunnerTblColAmount,
  RemittanceRunnerTblColDataDate,
  RemittanceRunnerTblColDataText,
  RemittanceRunnerTblColRider
} from "../RemittanceRunnerTableColumns";

export interface TableBodyContentProps {
  tblClasses: ClassNameMap<string>;
  numberOfColumns: number;
  dateFormat: string;
  loadingOrders: boolean;
  orderList: RemittanceRunnerOrders_remittanceOrders_edges_node[];
  checkedOrders: any[];
  handleChecked: (event: any, order_id: any) => void;
  forRemittance: boolean;
}

const TableBodyContent: React.FC<TableBodyContentProps> = props => {
  const {
    tblClasses,
    numberOfColumns,
    dateFormat,
    loadingOrders,
    orderList,
    checkedOrders,
    handleChecked,
    forRemittance
  } = props;

  const getTableBodyContentToRender = () => {
    let contentToRender;

    if (loadingOrders) {
      contentToRender = (
        <TableRow>
          <TableCell colSpan={numberOfColumns}>
            <RemittanceRunnerRemittanceIsLoading
              className={tblClasses.toRemitTableForLoading}
            />
          </TableCell>
        </TableRow>
      );
    } else if (!loadingOrders && orderList.length === 0) {
      contentToRender = (
        <TableRow>
          <TableCell colSpan={numberOfColumns}>
            {"No mother orders found"}
          </TableCell>
        </TableRow>
      );
    } else {
      contentToRender = (
        <>
          {orderList.map(order => (
            <TableRow key={order.id}>
              <TableCell padding="checkbox">
                <Checkbox
                  key={"chk" + order.id}
                  id={"chk" + order.id}
                  checked={checkedOrders.includes(order.id)}
                  onChange={ev => handleChecked(ev, order.id)}
                />
              </TableCell>
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <RemittanceRunnerTblColDataText
                  dataTitle={"Mother Order"}
                  dataValue={order?.orderCode}
                />
              </TableCell>
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <RemittanceRunnerTblColDataDate
                  dataTitle={"Date Shipped"}
                  dataValue={order?.shippedAt}
                  dateFormat={dateFormat}
                />
              </TableCell>
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <RemittanceRunnerTblColDataDate
                  dataTitle={"Date Completed"}
                  dataValue={order?.completedAt}
                  dateFormat={dateFormat}
                />
              </TableCell>
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <RemittanceRunnerTblColDataText
                  dataTitle={"Delivery Type"}
                  dataValue={getDeliveryTypeString(
                    order?.shippingMethod?.deliveryType
                  )}
                />
              </TableCell>
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <RemittanceRunnerTblColAmount order={order} />
              </TableCell>
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <RemittanceRunnerTblColRider order={order} />
              </TableCell>
              {forRemittance && (
                <TableCell
                  className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
                >
                  <RemittanceRunnerTblColDataText
                    dataTitle={""}
                    dataValue={order?.isPaymentCollected ? "Yes" : "No"}
                  />
                </TableCell>
              )}
            </TableRow>
          ))}
        </>
      );
    }
    return contentToRender;
  };

  return getTableBodyContentToRender();
};

export default TableBodyContent;
